import './context-menu.css';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react';

import { useMindmap } from '../../../pages/mindmap/use-mindmap';
import { openInNewTab } from '../../../utils/open-in-new-tab';
import { toUrl } from '../../../utils/to-url';

export const LinkTextContextMenu = () => {
  const {
    contextMenu: { activeMenu },
  } = useMindmap();

  const [newUrl, setNewUrl] = useState<string>('');

  const url = activeMenu?.type === 'link-text' ? activeMenu.url : '';

  const onOpenClick = () => openInNewTab(toUrl(newUrl || url));

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;
    setNewUrl(value);
    if (activeMenu?.type == 'link-text') {
      activeMenu.onUpdateURL(value);
    }
  };

  return (
    <div className="context-menu">
      <div className="field mb-0">
        <div className="p-inputgroup">
          <InputText
            placeholder="URL"
            className="block p-inputtext-sm"
            defaultValue={activeMenu?.type === 'link-text' ? activeMenu.url : ''}
            onChange={onChange}
          />
          <Button icon="pi pi-external-link" className="p-button-secondary p-button-outlined" onClick={onOpenClick} />
        </div>
      </div>
    </div>
  );
};
